/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable no-useless-escape */
import i18n from 'i18n';
import * as Yup from 'yup';

const schema = {
  default: {
    name: Yup.string()
      .required(i18n.t('REQUIRED_FIELD_KEY'))
      .max(
        40,
        i18n.t('MAX_LENGTH_KEY', {
          value: 40,
        })
      ),
    description: Yup.string()
      .required(i18n.t('REQUIRED_FIELD_KEY'))
      .max(
        50,
        i18n.t('MAX_LENGTH_KEY', {
          value: 50,
        })
      ),
  },

  aws: {
    key_pair: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
    primary_zone: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
    secondary_zone: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
    image_id: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
    security_group: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
    flavor: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
  },

  oci: {
    image_id: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
    zone: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
    flavor: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
    security_group: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
    subnet: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
  },
  ociBootVolume: {
    boot_volume_id: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
    zone: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
    flavor: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
    security_group: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
    subnet: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
  },
  ociBootVolumeBackup: {
    boot_volume_backup_id: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
    zone: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
    flavor: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
    security_group: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
    subnet: Yup.string().required(i18n.t('REQUIRED_FIELD_KEY')),
  },
};

export default {
  micro: Yup.object().shape(schema.default),
  multicloud: Yup.object().shape(schema.default),
  aws: Yup.object().shape({
    ...schema.default,
    provider_data: Yup.object().shape({
      ...schema.aws,
    }),
  }),
  oci: Yup.object().shape({
    ...schema.default,
    provider_data: Yup.object().shape({
      ...schema.oci,
    }),
  }),
  ociBootVolume: Yup.object().shape({
    ...schema.default,
    provider_data: Yup.object().shape({
      ...schema.ociBootVolume,
    }),
  }),
  ociBootVolumeBackup: Yup.object().shape({
    ...schema.default,
    provider_data: Yup.object().shape({
      ...schema.ociBootVolumeBackup,
    }),
  }),
};
